<template>
  <el-input v-model="tValue" placeholder="Search & select" clearable size="mini" @blur="handleBlur"></el-input>
</template>

<script>
import { mapGetters } from 'vuex'

let searchHandler = null
export default {
  name: 'ColumnProductNameInput',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    },
    source: {
      type: String,
      default: 'editOrderLine'
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  created () {
    if (this.source === 'editOrderLine') {
      this.localValue = this.product(this.rowId).name
    } else {
      this.localValue = this.rProduct(this.rowId).product.name
    }

    this.bus.$on(`product-selected-${this.rowId}`, product => {
      this.localValue = product.name
    })
  },
  beforeDestroy () {
    this.bus.$off(`product-selected-${this.rowId}`)
  },
  computed: {
    ...mapGetters({
      product: 'edit/lineProduct',
      rProduct: 'report/product'
    }),
    tValue: {
      get () {
        return this.localValue
      },
      set (val) {
        this.localValue = val
        if (searchHandler === null) {
          searchHandler = setTimeout(() => {
            this.bus.$emit(`name-changed-${this.rowId}`, this.localValue)
            searchHandler = null
          }, 500)
        }
      }
    }
  },
  methods: {
    handleBlur () {
      this.bus.$emit(`name-poper-leave-${this.rowId}`, this.localValue)
    }
  },
  inject: ['bus']
}
</script>
